export const LOGO_URL =
  'https://static.rfstat.com/renderforest/images/v2/graphic-maker/rf-logo-blue.png'

const FLAG_URL_MAIN = `https://static.rfstat.com/renderforest/images/v2/new-homepage/flags`

export const GB_FLAG = `${FLAG_URL_MAIN}/gb.svg`
export const BR_FLAG = `${FLAG_URL_MAIN}/br.svg`
export const ES_FLAG = `${FLAG_URL_MAIN}/es.svg`
export const DE_FLAG = `${FLAG_URL_MAIN}/de.svg`
export const FR_FLAG = `${FLAG_URL_MAIN}/fr.svg`
export const AE_FLAG = `${FLAG_URL_MAIN}/ae.svg`
export const JP_FLAG = `${FLAG_URL_MAIN}/jp.svg`
export const TR_FLAG = `${FLAG_URL_MAIN}/tr.svg`
export const RU_FLAG = `${FLAG_URL_MAIN}/ru.svg`

export const THUNDER_ICON =
  'https://cdn.renderforest.com/assets/refill-upgrade.svg'
